module.exports = __webpack_public_path__ + "img/snack-outline-blue.39624020.svg";